/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,
	AlignmentControl,
	BlockControls
} from "@wordpress/block-editor";
import {
	TextControl,
	SelectControl,
	RangeControl,
	PanelBody
} from "@wordpress/components";
import { Fragment } from "@wordpress/element";
import ServerSideRender from "@wordpress/server-side-render";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { dateFormat, customDate, fontSize, color, textAlign } = attributes;
	const dateFormatOptions = [
		{ label: "2024-09-19", value: "Y-m-d" },
		{ label: "09-19-2024", value: "m-d-Y" },
		{ label: "2024/09/19", value: "Y/m/d" },
		{ label: "09/19/2024", value: "m/d/Y" },
		{ label: "19th September 2024", value: "jS F Y" },
		{ label: "September 19 2024", value: "F j Y" },
		{ label: "Sep 19 2024", value: "M j Y" },
		{ label: "19th, Sep 2024", value: "jS, M Y" },
		{ label: "2024 19 Sep", value: "Y j M" },
		{ label: __("Custom Date Format", "templazee"), value: "customDate" },
	];


	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<PanelBody
				title={__("Date Settings", "templazee")}
				>
				

				<PanelColorSettings
					title={__("Color Settings", "templazee")}
					colorSettings={[
						{
							label: __("Text Color", "templazee"),
							value: color,
							onChange: (newColor) =>
								setAttributes({ color: newColor }),
						},

					]}
					initialOpen={false} />

				<RangeControl
					 label={__("Font Size", "templazee")}
					value={fontSize}
					onChange={(newSize) => setAttributes({ fontSize: newSize })}
					min={0}
					max={50}
				/>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={(nextAlign) => {
							setAttributes({ textAlign: nextAlign });
						}}
					/>
				</BlockControls>
				</PanelBody>

			</InspectorControls>
			<ServerSideRender
				block="templazee/date"
				attributes={attributes}
			/>
		</div>
	);
}

